import {
  DOCTOR_INFORMATION_SUCCESS,
  DOCTOR_MEDICAL_LICENCE_SUCCESS,
  SET_DOCTOR_PROFILE,
  SET_DOCTOR_PROFILE_LOADING,
  SET_DOCTOR_ERROR,
  GET_DOCTOR_PROFILE_LOADING,
  SET_PROVIDER_STATUS,
  SET_VALIDATION_PROVIDER_EMAIL,
  SET_ORIGINAL_PROFILE,
  MODIFY_PROFILE
} from '../mutation-types'

export default {
  [DOCTOR_INFORMATION_SUCCESS]: (state, doctorInformation) => {
    state.doctorInformation = doctorInformation
  },
  [DOCTOR_MEDICAL_LICENCE_SUCCESS]: (state) => {
    state.loadedDoctorInformation = true;
    state.doctorMedicalLicenseStatus = 'success'
  },
  [SET_DOCTOR_PROFILE]: (state, payload) => {
    state.profile = payload
  },
  [SET_DOCTOR_PROFILE_LOADING]: (state, payload) => {
    state.loadDoctorProfileLoading = payload
  },
  [SET_DOCTOR_ERROR]: (state, payload) => {
    state.error = payload
  },
  [GET_DOCTOR_PROFILE_LOADING]: (state, payload) => {
    state.getDoctorProfileLoading = payload
  },
  [SET_PROVIDER_STATUS]: (state, payload) => {
    state.providerStatus = payload
  },
  [SET_VALIDATION_PROVIDER_EMAIL]: (state, payload) => {
    state.providerEmailValidation = payload
  },
  [SET_ORIGINAL_PROFILE]: (state, payload) => {
    state.originalProfile = payload
  },
  [MODIFY_PROFILE]: (state, payload) => {
    state.modifyProfile = payload
  }
}